import { StringifiableRecord } from "query-string";
import { fetcher, IOptions } from "./share";

const clientFether = async (url: string, options: Omit<IOptions, "baseUrl"> = {}) => {
   return fetcher(url, { ...options, baseUrl: '/api' });
};

export const get = async (url: string, params?: StringifiableRecord) => {
  return clientFether(url, { method: "GET", params });
};

export const post = async (url: string, data?: Record<string, unknown> | FormData) => {
  return clientFether(url, { method: "POST", data });
};

export const postFormData = async (url: string, data?: Record<string, unknown>) => {
  return clientFether(url, { method: "POST", data, isFormData: true, returnOrigin: true, });
};
